<template>
  <span class="auction-time" id="countdown">
    <!-- Auction didn't start -->
    <span v-if="deadline == null">
      {{ $t('filter.auctionDidntStart') }}
    </span>

    <!-- Auction ended -->
    <span v-else-if="ended">
      {{ $t('filter.auctionEnded') }}
    </span>

    <!-- Auction running -->
    <span v-else class="countdown-amount">
      <template v-if="days > 0">
        {{ days | formatTime }} j
      </template>

      <template v-if="hours > 0">
        {{ hours | formatTime }} h
      </template>

      <template v-if="isLong || days == 0">
        {{ minutes | formatTime }} m
      </template>

      <template v-if="isLong || hours == 0">
        {{ seconds | formatTime }} s
      </template>
    </span>
  </span>
</template>

<script>
export default {
  name: "TimerSimpleLong",
  props: {
    timeLeft: {
      type: Number,
      required: true,
    },
    deadline: {
      type: String,
      required: false,     // allow null
      default: null,
    },
    duration: {
      type: Number,
      required: true,
    },
    isLong: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      speed:1000,
      currentTime: 0,
      timerInterval: null,
    };
  },
  methods: {
    startCountdown() {
      if (!this.deadline) return; // Auction not started

      const deadlineTime=Date.parse(this.deadline);
      if (isNaN(deadlineTime)) return;

      this.timerInterval=setInterval(() => {
        const now=Date.now();
        const durationMs=this.duration*24*60*60*1000;

        this.currentTime=deadlineTime+durationMs-now;

        if (this.currentTime<=0) {
          this.currentTime=0;   // avoid negative values
          clearInterval(this.timerInterval);
        }
      }, this.speed);
    },
  },
  computed: {
    ended() {
      // Auction ended only when currentTime reaches 0 and deadline exists
      return this.deadline!=null&&this.currentTime===0;
    },
    seconds() {
      return Math.floor((this.currentTime/1000)%60);
    },
    minutes() {
      return Math.floor((this.currentTime/1000/60)%60);
    },
    hours() {
      return Math.floor((this.currentTime/(1000*60*60))%24);
    },
    days() {
      return Math.floor(this.currentTime/(1000*60*60*24));
    },
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  },
  filters: {
    formatTime(value) {
      return value<10? "0"+value:value;
    },
  },
};
</script>

<style scoped>
.auction-time {
  display: inline;
}

.countdown-amount {
  font-weight: bold;
  display: inline;
}

.countdown-amount>*+* {
  margin-left: 0.5rem;
}
</style>
